'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderEmail = orderEmail;
function useOrderEmail(order, user) {
  if (order.billAddress) return true;
  if (!user) return true;
  if (order.email === user.login) return true;

  return false;
}

function orderEmail(order, user) {
  if (useOrderEmail(order, user)) {
    return order.email;
  }

  return user.email || '';
}


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/user.js
// module id = 559
// module chunks = 0